import wx from 'weixin-js-sdk';

const wechat = {
  share(options) {
    console.log(options)
    wx.config({
      debug: false,
      appId: options.appid,
      timestamp: options.timestamp,
      nonceStr: options.noncestr,
      signature: options.signature,
      jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData']
    });
    wx.ready(function () {
      wx.updateTimelineShareData({
        // 分享标题
        title: options.share_title,
        // title: "2024全球技术转移大会 InnoMatch EXPO",
        // 分享链接
        link: options.url,
        // 分享图标
        imgUrl: options.share_thumb,
        success: function success() {
          console.log('yes')
        },
        cancel: function cancel() {
          // 用户取消分享后执行的回调函数
        }
      });
      wx.updateAppMessageShareData({
        // 分享标题
        title: options.share_title,
        // 分享描述
        desc: options.share_info,
        // 分享链接
        link: options.url,
        // 分享图标
        imgUrl: options.share_thumb,
        // 分享类型,music、video或link，不填默认为link
        type: '',
        // 如果type是music或video，则要提供数据链接，默认为空
        optionsUrl: '',
        success: function success() {
          console.log('yes1')
          // alert(123);
          // 用户确认分享后执行的回调函数
        },
        cancel: function cancel() {
          // 用户取消分享后执行的回调函数
        }
      });
    });
    wx.error(function (res) {
      // alert('err---' + JSON.stringify(res));
      console.log(JSON.stringify(res))
    });
  }
};

export default wechat;
